import { useEffect, useState } from "react";
import styled from "styled-components";
import { Popconfirm, message, Checkbox } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { StyledModal } from "components/App/styled";

import Button from "components/buttons/Button";
import Fetch from "components/Fetch";
import colors from "constants/palette";

// states:::
// 0 submited - processing
// 1 processed - ready to send
// 2 waiting for payment
// 3 done

export default function FinishButton({ data, reload }) {
  const [visible, setVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const payments = JSON.parse(data.data).payments;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (refresh) {
      setRefresh(false);
    }
  }, [refresh]);
  const showPopconfirm = () => {
    setVisible(true);
  };
  const handleConfirm = (key) => {
    var detailData = JSON.parse(data.data);
    //  update order data
    detailData.payments[key] = { ...detailData.payments[key], status: 1 };

    setLoading(true);
    Fetch.put(
      `/payments/confirm/${detailData.payments[key].id}`,
      { orderId: data.id, newOrderData: detailData },
      (res) => {
        console.log("confirm payment response", res);
        if (res.ok) {
          message.success("با موفقیت انجام شد");
        } else {
          message.error("خطایی رخ داده است");
        }

        if (
          detailData.payments.filter((item) => item.status === 0 && true)
            .length === 0
        ) {
          Fetch.put(`/orders/state/${data.id}`, { state: 3 }, (res) => {
            console.log("orders close response", res);
            if (res.ok) {
              message.success("سفارش با موفقیت به پایان رسید");
            } else {
              message.error("خطایی در بستن سفارش رخ داده است");
            }
          });
        }

        setLoading(false);
        setVisible(false);

        reload(true);
      }
    );
  };

  const handleCancel = () => {
    setVisible(false);
  };
  return (
    <>
      <Button
        color={colors.green}
        style={{ marginRight: 6 }}
        onClick={showPopconfirm}
      >
        <CheckOutlined />
      </Button>
      <StyledModal
        visible={visible}
        onCancel={handleCancel}
        closable={false}
        title="مدیریت پرداختی ها"
        footer={[
          <Button
            key="close"
            onClick={handleCancel}
            type="primary"
            loading={loading}
            style={{ width: "100%" }}
            color={colors.dark}
          >
            بستن
          </Button>,
        ]}
        width={680}
      >
        <Container>
          {data.state === 2
            ? payments.map((item, key) => (
                <Row key={key}>
                  <div>{item.type === 0 ? "نقدی" : "چک"}</div>
                  <div>{item.amount}</div>
                  <div>{new Date(item.time).toLocaleDateString("fa-ir")}</div>
                  <div>{item.description}</div>
                  <div>
                    {item.status === 0 ? (
                      <Button
                        onClick={() => handleConfirm(key)}
                        color={colors.green}
                      >
                        <CheckOutlined />
                      </Button>
                    ) : (
                      <div className="center" style={{ width: 50, height: 40 }}>
                        <CheckOutlined style={{ color: colors.green }} />
                      </div>
                    )}
                  </div>
                </Row>
              ))
            : " سفارشی ارسال نشده است"}
        </Container>
      </StyledModal>
    </>
  );
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;
